import { async, errorPrefix } from "@firebase/util";
import { auth, firebase, firestore } from "./firebase";

const CATEGORIES = "categories";

//取得文章下特定主題的內容
export async function getArticleCategorys(genre, articleType) {
  console.log(articleType);
  return await firestore
    .collection("articles")
    .doc(genre)
    .collection(articleType)
    .get()
    .then((data) => {
      return data;
    })
    .catch((err) => {
      return err;
    });
}

export async function getCategorys() {
  return await firestore
    .collection(CATEGORIES)
    .get()
    .then((data) => {
      return data;
    })
    .catch((data) => {
      return data;
    });
}

export async function uploadToArticles({
  editId,
  catid,
  thumbnail,
  title,
  tag,
  publishDate,
  text,
}) {
  console.log(text);
  console.log(title);
  //編輯 or 新建
  var postRef = editId
    ? firestore.collection("blog").doc(editId)
    : firestore.collection("blog").doc();

  console.log(postRef);
  console.log(postRef.id);
  var blogTextRef = firestore.collection("blogText").doc(postRef.id);
  //新資料
  const batch = firestore.batch();
  var newPostPreviewData = { title, catid, tag, publishDate, thumbnail };
  
  console.log(newPostPreviewData);
  batch.set(postRef, newPostPreviewData);
  //內文
  var postContextData = { text };
  batch.set(blogTextRef, postContextData);

  //編輯時間:
  const timestamp = firebase.firestore.FieldValue.serverTimestamp();
  batch.update(postRef, { updatedAt: timestamp });

  //若是新資料才須執行
  if (!editId) {
    //更新至user
    const userRef = firestore.collection("users").doc(auth.currentUser.uid);
    batch.update(userRef, {
      articles: firebase.firestore.FieldValue.arrayUnion(postRef),
    });
    //計數器
    const statesRef = firestore.collection("blog").doc("--state--");
    const increment = firebase.firestore.FieldValue.increment(1);
    batch.set(statesRef, { count: increment }, { merge: true });
  }

  return await batch.commit();
}

export async function getArticlesPreview({
  catid,
  orderBy = "updatedAt",
  startAfter = null,
  limit = 5,
}) {
  if (catid == "all") {
    //當catid="all"，回傳全部
    return await firestore
      .collection("blog")
      .orderBy(orderBy, "desc")
      .endBefore(startAfter)
      .get()
      .then((snapshot) => {
        return snapshot.docs;
      });
  } else {
    //返回特定cat的文章
    return await firestore
      .collection("blog")
      .where("catid", "==", catid)
      .orderBy(orderBy, "desc")
      .endBefore(startAfter)
      //.limit(limit)
      .get()
      .then((snapshot) => {
        return snapshot.docs;
      });
  }
}

export async function getArticleByid(aid) {
  var preView = firestore.collection("blog").doc(aid);
  var context = firestore.collection("blogText").doc(aid);
  /*
  return await preView
    .get()
    .then((snap)=>{
      context.get().then((_snap)=>{
        return {...snap.data() ,..._snap.data()}
      })
    })
  */
  return await firestore
    .collection("blog")
    .doc(aid)
    .get()
    .then((snapshot) => {
      return snapshot;
    });
}

export async function getArticleTextByid(aid){
  return await firestore
    .collection("blogText")
    .doc(aid)
    .get()
    .then((snapshot) => {
      return snapshot;
    });
}

//傳入 tag陣列，返回任何有其中一個tag以上的文章
export async function getArticlesByTag(tagIds = [""]) {
  console.log(tagIds);

  return await firestore
    .collection("blog")
    .where("tag", "array-contains-any", tagIds)
    .get()
    .then((sp) => {
      return sp;
    });
}
export async function searchAllArticles(input) {
  var ref = firestore
    .collection("blog")
    .chiild("data")
    .orderByChild("text")
    .equalTo(input);
  //ref.chiild("data").orderByChild("data").equalTo(true);
  return await ref.get().then((sp) => {
    return sp;
  });
}

export async function deleteArticel(aid) {
  var dref = firestore.collection("blog").doc(aid);
  var textRef= firestore.collection("blogText").doc(aid);

  const batch = firestore.batch();
  //刪除文章
  batch.delete(dref);
  batch.delete(textRef)
  //計數器
  const statesRef = firestore.collection("blog").doc("--state--");
  //文章數量減少
  const decrement = firebase.firestore.FieldValue.increment(-1);
  batch.set(statesRef, { count: decrement }, { merge: true });
  //從user文章刪除
  const userRef = firestore.collection("users").doc(auth.currentUser.uid);
  batch.update(userRef, {
    articles: firebase.firestore.FieldValue.arrayRemove(dref),
  });

  return await batch.commit();
}

//[沒再用]: 新增分類
export async function addNewCategory(_catName) {
  const ref = firestore.collection(CATEGORIES).doc();
  return await firestore.collection(CATEGORIES).set(_catName, { merge: true });
}
